export default function start({render}) {
  function _start() {
    if (typeof render === 'function') {
      render();
    }
  }

  /**
   * Check is there some basic ES5/6 features available. If yes - proceed without loading the whole es-core.
   */
  if (
    'fetch' in window &&
    'Intl' in window &&
    'URL' in window &&
    'Map' in window &&
    'forEach' in NodeList.prototype &&
    'startsWith' in String.prototype &&
    'endsWith' in String.prototype &&
    'includes' in String.prototype &&
    'includes' in Array.prototype &&
    'assign' in Object &&
    'entries' in Object &&
    'keys' in Object
  ) {
    _start();
  } else {
    Promise.all([
      import(/* webpackChunkName: "swi-polyfill-core-js" */ 'core-js/stable'),
      import(/* webpackChunkName: "swi-polyfill-regenerator" */ 'regenerator-runtime'),
    ])
      .then(() => {
        return _start();
      })
      .catch(() => {
        // Empty
      });
  }
}
